/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import format from 'date-fns/format';

export default class DateTimeHelper {

	static formatTimestamp(timestamp) {
		return format(new Date(timestamp), 'HH:mm:ss');
	}
}
